import React from 'react';
import PropTypes from 'prop-types';

import { Button, H2, P, Flex } from '@decisiv/ui-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

import Toasts from 'components/Toasts';

import LocalizedPasswordField from '../../LocalizedPasswordField';
import useSetPassword from './hooks/useSetPassword';

function ExtraInfo({ html }) {
  return (
    <P
      weight="regular"
      shade={1}
      style={{ fontSize: '12px', textAlign: 'center', marginTop: '0px' }}
    >
      {/* eslint-disable-next-line react/no-danger */}
      <span dangerouslySetInnerHTML={{ __html: html }} />
    </P>
  );
}

ExtraInfo.propTypes = {
  html: PropTypes.string,
};

ExtraInfo.defaultProps = {
  html: '',
};

function PasswordDetails({ translations }) {
  return (
    <P style={{ fontSize: '14px', color: '#3E3F4D', marginTop: '25px' }}>
      <span style={{ fontWeight: '600' }}>
        {translations.passwordRequirements}
      </span>
      <ul>
        <li>{translations.passwordRequirementLength}</li>
        <li>{translations.passwordRequirementCase}</li>
        <li>{translations.passwordRequirementAlphanumeric}</li>
      </ul>
    </P>
  );
}

PasswordDetails.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string),
};

PasswordDetails.defaultProps = {
  translations: {},
};

function PasswordRequest({ userId, csrfToken, targetUrl, translations }) {
  const onSuccess = () => {
    window.location = targetUrl;
  };

  const {
    setPassword,
    postPassword,
    setCheckPassword,
    isDirty,
  } = useSetPassword(userId, csrfToken, onSuccess);

  const welcomeMarkup = { __html: translations.welcomeHtml };
  const introMarkup = { __html: translations.introHtml };

  return (
    <div>
      <Toasts />
      <Flex
        justifyContent="center"
        alignItems="center"
        style={{ minHeight: '80vh' }}
      >
        <Flex flexDirection="column" style={{ maxWidth: '390px' }}>
          <H2 style={{ padding: '0px', margin: '0px' }}>
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={welcomeMarkup} />
          </H2>
          <p style={{ margin: '15px 0px', fontSize: '14px', color: '#737482' }}>
            {/* eslint-disable-next-line react/no-danger */}
            <span dangerouslySetInnerHTML={introMarkup} />
          </p>
          <Flex
            flexDirection="column"
            style={{ backgroundColor: toColorString(color.opacity.fullMoon50) }}
            padding={2}
          >
            <LocalizedPasswordField
              style={{ marginBottom: '10px' }}
              label={translations.password}
              showPasswordLabel={translations.showPassword}
              hidePasswordLabel={translations.hidePassword}
              name="password"
              required
              onChange={(e) => setPassword(e.target.value)}
            />
            <LocalizedPasswordField
              label={translations.confirmPassword}
              showPasswordLabel={translations.showPassword}
              hidePasswordLabel={translations.hidePassword}
              name="confirmPassword"
              required
              onChange={(e) => setCheckPassword(e.target.value)}
            />
            <Flex justifyContent="space-between" marginTop={1}>
              <Button
                text={translations.setUpMyPassword}
                kind="primary"
                disabled={isDirty()}
                onClick={() => postPassword()}
              />
            </Flex>
            <PasswordDetails translations={translations} />
            <ExtraInfo html={translations.agreementHtml} />
          </Flex>
        </Flex>
      </Flex>
    </div>
  );
}

PasswordRequest.propTypes = {
  userId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  targetUrl: PropTypes.string.isRequired,
  translations: PropTypes.objectOf(PropTypes.string),
};

PasswordRequest.defaultProps = {
  translations: {},
};

export default PasswordRequest;
